<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Nombre</th>
          <th scope="col">PerfilNombre</th>
          <th scope="col">PersonaDocumento</th>
          <th scope="col">PersonaNombre</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usuario in datosPaginados" :key="usuario.idUsuario">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(usuario.idUsuario)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(usuario.idUsuario)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ usuario.nombre }}</td>
          <td>{{ usuario.perfilNombre }}</td>
          <td>{{ usuario.personaDocumento }}</td>
          <td>{{ usuario.personaNombre }}</td>
          <td>{{ usuario.empresaNombre }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteUsuario(usuario.idUsuario)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuario" class="form-label">IdUsuario</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuario"
                      name="idUsuario"
                      v-model="datoUsuario.idUsuario"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPerfil"
                      name="idPerfil"
                      v-model="datoUsuario.idPerfil"
                    >
                      <option
                        v-for="perfil in perfils"
                        :value="perfil.idPerfil"
                        :key="perfil.idPerfil"
                      >
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label">
                      Suscripcion</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idSuscripcion"
                      name="idSuscripcion"
                      v-model="datoUsuario.idSuscripcion"
                    >
                      <option
                        v-for="suscripcion in suscripcions"
                        :value="suscripcion.idSuscripcion"
                        :key="suscripcion.idSuscripcion"
                      >
                        {{ suscripcion.idSuscripcion }} -
                        {{ suscripcion.numero }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoUsuario.nombre"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="clave" class="form-label">Clave</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="clave"
                      name="clave"
                      v-model="datoUsuario.clave"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label"
                      >IdUsuarioReg</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioReg"
                      name="idUsuarioReg"
                      v-model="datoUsuario.idUsuarioReg"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label"
                      >IdUsuarioAct</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioAct"
                      name="idUsuarioAct"
                      v-model="datoUsuario.idUsuarioAct"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      v-model="datoUsuario.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaAct"
                      name="fechaAct"
                      v-model="datoUsuario.fechaAct"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloAdministracion" class="form-label"
                      >ModuloAdministracion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloAdministracion"
                      name="moduloAdministracion"
                      v-model="datoUsuario.moduloAdministracion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloAtencion" class="form-label"
                      >ModuloAtencion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloAtencion"
                      name="moduloAtencion"
                      v-model="datoUsuario.moduloAtencion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloFacturacion" class="form-label"
                      >ModuloFacturacion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloFacturacion"
                      name="moduloFacturacion"
                      v-model="datoUsuario.moduloFacturacion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloDashboards" class="form-label"
                      >ModuloDashboards</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloDashboards"
                      name="moduloDashboards"
                      v-model="datoUsuario.moduloDashboards"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuParametros" class="form-label"
                      >MenuParametros</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuParametros"
                      name="menuParametros"
                      v-model="datoUsuario.menuParametros"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuProcesos" class="form-label"
                      >MenuProcesos</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuProcesos"
                      name="menuProcesos"
                      v-model="datoUsuario.menuProcesos"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuReportes" class="form-label"
                      >MenuReportes</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuReportes"
                      name="menuReportes"
                      v-model="datoUsuario.menuReportes"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuAyuda" class="form-label">MenuAyuda</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuAyuda"
                      name="menuAyuda"
                      v-model="datoUsuario.menuAyuda"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionConsulta" class="form-label"
                      >OpcionConsulta</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionConsulta"
                      name="opcionConsulta"
                      v-model="datoUsuario.opcionConsulta"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionOperaciones" class="form-label"
                      >OpcionOperaciones</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionOperaciones"
                      name="opcionOperaciones"
                      v-model="datoUsuario.opcionOperaciones"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionDescarga" class="form-label"
                      >OpcionDescarga</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionDescarga"
                      name="opcionDescarga"
                      v-model="datoUsuario.opcionDescarga"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionMenu" class="form-label"
                      >OpcionMenu</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionMenu"
                      name="opcionMenu"
                      v-model="datoUsuario.opcionMenu"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Persona -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPersona"
                      name="idPersona"
                      v-model="datoUsuario.idPersona"
                    >
                      <option
                        v-for="persona in personas"
                        :value="persona.idPersona"
                        :key="persona.idPersona"
                      >
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Persona -->
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                data-bs-dismiss="modal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                  >meeting_room</i
                >
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarUsuario"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditUsuario"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";
import { format } from "date-fns";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idEmpresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      usuarios: [],
      datoUsuario: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      perfils: [],
      perfilSeleccionadoDto: {},
      suscripcions: [],
      personas: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, "dd/MM/yyyy");
    },
  },

  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPerfils();
    this.fetchSuscripcions();
    this.fetchPersonas();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.usuarios.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwusuarios/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.usuarios = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.usuarios.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwusuarios").then((response) => {
        this.usuarios = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.usuarios.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idPerfil",
        "idSuscripcion",
        "nombre",
        "clave",
        "idPersona",
      ];
      const requiredFieldsText = [
        "idPerfil",
        "idSuscripcion",
        "nombre",
        "clave",
        "idPersona",
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async guardarUsuario() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuario.idUsuario =
            window.sessionStorage.getItem("idUsuario");
          this.datoUsuario.idEmpresa = this.p_idEmpresa;
          this.datoUsuario.idUsuarioReg =
            window.sessionStorage.getItem("idUsuarioReg");
          this.obtenerPerfil();
          this.datoUsuario.moduloAdministracion =
            this.perfilSeleccionadoDto.moduloAdministracion;
          this.datoUsuario.moduloAtencion =
            this.perfilSeleccionadoDto.moduloAtencion;
          this.datoUsuario.moduloAuditoria =
            this.perfilSeleccionadoDto.moduloAuditoria;
          this.datoUsuario.moduloFacturacion =
            this.perfilSeleccionadoDto.moduloFacturacion;
          this.datoUsuario.moduloDashboards =
            this.perfilSeleccionadoDto.moduloDashboards;
          this.datoUsuario.menuParametros =
            this.perfilSeleccionadoDto.menuParametros;
          this.datoUsuario.menuProcesos =
            this.perfilSeleccionadoDto.menuProcesos;
          this.datoUsuario.menuReportes =
            this.perfilSeleccionadoDto.menuReportes;
          this.datoUsuario.menuAyuda = this.perfilSeleccionadoDto.menuAyuda;
          this.datoUsuario.opcionConsulta =
            this.perfilSeleccionadoDto.opcionConsulta;
          this.datoUsuario.opcionOperaciones =
            this.perfilSeleccionadoDto.opcionOperaciones;
          this.datoUsuario.opcionDescarga =
            this.perfilSeleccionadoDto.opcionDescarga;
          this.datoUsuario.opcionMenu = this.perfilSeleccionadoDto.opcionMenu;
          await api.post("/usuarios",
            this.datoUsuario
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "Usuario creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditUsuario() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuario.idUsuarioAct =
            window.sessionStorage.getItem("idUsuarioAct");
          await api.post("/usuarios",
            this.datoUsuario
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Usuario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoUsuario = {};
      this.titulo = "Crear Usuarios";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idUsuario) {
      this.modalWindow = true;
      if (idUsuario != null) {
        api.get("/vwusuarios/" + idUsuario)
          .then((resp) => {
            this.datoUsuario = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Usuarios";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idUsuario) {
      if (idUsuario != null) {
        this.$router.push("/usuariomd/" + idUsuario);
      }
    },
    async deleteUsuario(idUsuario) {
      try {
        await api.delete("/usuarios/" + idUsuario
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchPerfils() {
      fetch(config.apiBaseUrl + "/vwperfils")
        .then((response) => response.json())
        .then((data) => {
          this.perfils = data;
        })
        .catch((error) => {
          console.error("Error fetching perfils:", error);
        });
    },
    fetchSuscripcions() {
      fetch(config.apiBaseUrl + "/vwsuscripcions")
        .then((response) => response.json())
        .then((data) => {
          this.suscripcions = data;
        })
        .catch((error) => {
          console.error("Error fetching suscripcions:", error);
        });
    },
    fetchPersonas() {
      fetch(config.apiBaseUrl + "/vwpersonas")
        .then((response) => response.json())
        .then((data) => {
          this.personas = data;
        })
        .catch((error) => {
          console.error("Error fetching personas:", error);
        });
    },
    obtenerPerfil() {
      fetch(config.apiBaseUrl + "/vwperfils/" + this.datoUsuario.idPerfil
      )
        .then((response) => response.text())
        .then((str) => {
          const parser = new DOMParser();
          const xml = parser.parseFromString(str, "application/xml");

          const dto = {
            idPerfil: xml.querySelector("idPerfil")?.textContent,
            nombre: xml.querySelector("nombre")?.textContent,
            moduloAdministracion:
              xml.querySelector("moduloAdministracion")?.textContent === "1",
            moduloAtencion:
              xml.querySelector("moduloAtencion")?.textContent === "1",
            moduloAuditoria:
              xml.querySelector("moduloAuditoria")?.textContent === "1",
            moduloFacturacion:
              xml.querySelector("moduloFacturacion")?.textContent === "1",
            moduloDashboards:
              xml.querySelector("moduloDashboards")?.textContent === "1",
            menuParametros:
              xml.querySelector("menuParametros")?.textContent === "1",
            menuProcesos:
              xml.querySelector("menuProcesos")?.textContent === "1",
            menuReportes:
              xml.querySelector("menuReportes")?.textContent === "1",
            menuAyuda: xml.querySelector("menuAyuda")?.textContent === "1",
            opcionConsulta:
              xml.querySelector("opcionConsulta")?.textContent === "1",
            opcionOperaciones:
              xml.querySelector("opcionOperaciones")?.textContent === "1",
            opcionDescarga:
              xml.querySelector("opcionDescarga")?.textContent === "1",
            opcionMenu: xml.querySelector("opcionMenu")?.textContent === "1",
            estado: xml.querySelector("estado")?.textContent === "1",
          };

          this.perfilSeleccionadoDto = dto; // ← asigna al objeto reactivo
        })
        .catch((error) => {
          console.error("Error al obtener perfil:", error);
        });
    },
  },
};
</script>
